import React from "react";
import { useState, useCallback, useEffect } from "react";
import UploadDocument from "./UploadDocument";
import { useTranslation } from "react-i18next";
import DotMenu from "shared/components/DotMenu";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import downloadFile from "shared/helpers/downloadFile";
import { deleteChapterFile } from "redux/actions/configAI/chapterFileUpdates";
const axios = require("axios");
const RAGFiles = ({ chapterId, bookId, organisationId, onFilesChange }) => {

    const [t] = useTranslation();
    const config = useSelector((state) => state.configAI.config);
    const aiMap = config.aiMap || [];
    const currentChapter = aiMap.find((item) => item.chapterId == chapterId) || {};
    const [files, setFiles] = useState(currentChapter.uploadedFiles || []);
    const { current: organisation } = useSelector(state => state.organisation);
    const dispatch = useDispatch();
    const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === "development");
    const API_BASE_URL = isDev
        ? "http://localhost:1337"
        : window.location.href.includes("acceptance")
            ? "https://acceptance.okcomply.com"
            : "https://my.okcomply.com";

    const ACTIONS = {
        DELETE: "DELETE",
        DOWNLOAD: "DOWNLOAD"
    };

    const setAction = async (action, file) => {
        if (action === ACTIONS.DELETE) {
            setFiles(prevFiles => prevFiles.filter(f => f.filename !== file.filename));
            dispatch(deleteChapterFile(chapterId, file.filename));
            await axios.post(`${API_BASE_URL}/invites/openai-rag-file-delete`, {
                filename: file.filename,
                chapterId,
                bookId,
                originalFileName: file.originalFileName
            });



        } else if (action === ACTIONS.DOWNLOAD) {
            downloadFile(file.filename, file.fileType, organisation.id, false);
        }
    };


    const renderDotmenu = (file) => {
        const menuItems = [
            { label: t("button.download.label"), action: () => setAction(ACTIONS.DOWNLOAD, file) },
            { label: t("button.delete.label"), action: () => setAction(ACTIONS.DELETE, file) },
        ];

        return (
            <div className="actions">
                <div className="vertical-divider" />
                <DotMenu menuItems={menuItems} />
            </div>
        );
    };

    const onUpload = useCallback((fullFile) => {
     
        setFiles((prev) => {
            const updated = [...prev, fullFile];
       
            return updated;
        });
    }, []);


    useEffect(() => {
        if (onFilesChange) {
            onFilesChange(files);
        }
    }, [files, onFilesChange]);

    return (
        <>
            <div >
                {files.map((fullFile, index) => (
                    <div key={index} className="file-item">
                        <div className="col-12 file-header">
                            <div className="text-muted">{fullFile.originalFileName}</div>
                            {renderDotmenu(fullFile)}
                        </div>

                    </div>
                ))}
            </div>
            <UploadDocument
                onUpload={onUpload}
                chapterId={chapterId}
                bookId={bookId}
                organisationId={organisationId}
            ></UploadDocument>
        </>
    );
};

export default RAGFiles;

